<template>
  <div class="wtv-hotel-list">
    <div data-stats="open_tour_from_hotel_list" class="wtv-hotel"
      v-for="hotel in list" :key="hotel.hotelcode"
      @click="openTour(hotel.hotelcode, getTour(hotel), cellIndex ? cellIndex : cellIndexFromStore)"
      :class="{ 'wtv-selected': hasSelected }">
      <div class="wtv-hotel-name">
        {{ hotel.hotelname?.toLowerCase() }}
        <!-- {{ hotel.regionname?.toLowerCase() }} -->
        <HotelStars v-if="hotel.hotelstars" :amount="hotel.hotelstars" />
      </div>
      <div class="wtv-hotel-meta-row">
        <div class="wtv-hotel-meta wtv-icon wtv-icon-flydate">
          {{ getTour(hotel).flydate }}
        </div>
        <div class="wtv-hotel-meta wtv-icon wtv-icon-adults">
          {{ getTour(hotel).adults }}
        </div>
        <div class="wtv-hotel-meta wtv-icon wtv-icon-nights">
          {{ getTour(hotel).nights }}
        </div>
      </div>

      <div class="wtv-price wtv-nowrap">
        {{ hotel.price?.toLocaleString() }}
        <span class="wtv-lower">руб.</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import HotelStars from '@/components/HotelStars.vue';

export default defineComponent({
  props: {
    list: Array,
    hasSelected: Boolean,
    cellIndex: Number,
  },
  components: {
    HotelStars,
  },
  setup() {
    const $store = useStore();
    const { hotelInfo, cellResult } = $store.getters;
    const cellIndexFromStore = computed(() => $store.state.cellIndex);
    // const state = computed(() => $store.state);
    // const cell = computed(() => state.value.cells[props.index as number]);
    // const hotelList = computed(() => state.value.result[props.index as number]?.hotel);

    const getTour = (hotel: { tours: { tour: unknown[] } } | false) => {
      if (!hotel || !hotel.tours || !hotel.tours.tour) return false;

      return hotel.tours.tour[0];
    };

    // const setTour = (newTour: unknown) => $store.commit('setTour', newTour);

    const openTour = (hotelcode: string | number, tour: unknown, i = 0) => {
      const e = window.event as Event;
      $store.dispatch('sendStats', {
        cell: $store.state.initials.list[i],
        type: (e.target as HTMLDivElement)?.dataset?.stats,
      });

      $store.commit('setCellIndex', i);

      if (!hotelInfo(hotelcode)) {
        $store.dispatch('getHotel', hotelcode);
      }

      const list = cellResult(i)?.hotel;
      $store.commit('setRelatedList', list);
      $store.dispatch('actualize', tour);
    };
    return {
      getTour,
      // setTour,
      openTour,
      cellIndexFromStore,
      // state,
      // cell,
      // hotelList,
    };
  },
});
</script>

<style scoped>
.wtv-hotel-list {
  width: 100%;
  height: 365px;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-dark);
}

.wtv-hotel {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 4px 12px;
  /* border: 1px solid var(--color-alt-5); */
  margin: 1px 0 0 0;
  background-color: var(--color-paper);
  cursor: pointer;
}

.wtv-hotel-meta-row {
  display: flex;
}

.wtv-hotel-name {
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-size: 16px;
  font-weight: 600;
}

.wtv-hotel-meta {
  margin: 0 8px;
}

.wtv-hotel-meta::before {
  margin-right: 4px;
}
</style>
